var _excluded = ["appearance", "behavior", "gutter", "hoverable", "id", "items", "onCollapse", "onExpand", "onScrollEnd", "scrollEndOffset"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import AccordionContext from './accordion_context';
import AccordionItem from './accordion_item';
import propTypes from './prop_types';
import scrollEnded from '../utils/scroll_ended';
import { useStyles } from './use_styles';

/**
 * Consider the first item expanded as the initial `singleExpandedItem`
 *  if the behavior is `singleExpand`.
 * @param {*} items
 */
import { jsx as ___EmotionJSX } from "@emotion/core";
function getInitialExpandedItem(items) {
  var expandedIndex = items.reduce((array, item, index) => {
    if (item.expanded) {
      return array.concat(index);
    }
    return array;
  }, []);
  return expandedIndex === null || expandedIndex === void 0 ? void 0 : expandedIndex[0];
}
var Accordion = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      appearance,
      behavior = 'multiExpand',
      gutter = 0,
      hoverable = false,
      id: accordionID,
      items = [],
      onCollapse,
      onExpand,
      onScrollEnd,
      scrollEndOffset
    } = _ref,
    accordionProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var style = useStyles({
    appearance,
    gutter
  });
  var hasSingleBehavior = behavior === 'singleExpand';
  var handleOnScrollEnd = React.useCallback(event => {
    if (scrollEnded(event.currentTarget, scrollEndOffset)) onScrollEnd === null || onScrollEnd === void 0 ? void 0 : onScrollEnd(event);
  }, [onScrollEnd, scrollEndOffset]);
  var [singleExpandedItem, setSingleExpandedItem] = React.useState(() => getInitialExpandedItem(items));
  return ___EmotionJSX(AccordionContext.Provider, {
    value: {
      appearance,
      gutter,
      hasSingleBehavior,
      hoverable,
      items,
      onCollapse,
      onExpand,
      singleExpandedItem
    }
  }, ___EmotionJSX("div", _extends({
    css: style.container,
    "data-allow-multiple": !hasSingleBehavior,
    "data-allow-toggle": hasSingleBehavior,
    id: accordionID,
    onScroll: handleOnScrollEnd,
    ref: ref
  }, accordionProps), items === null || items === void 0 ? void 0 : items.map((item, index) => ___EmotionJSX(AccordionItem, {
    hasSingleBehavior: hasSingleBehavior,
    index: index,
    item: item,
    key: "accordion_item-".concat(item.id),
    onSingleExpandChange: setSingleExpandedItem
  }))));
});
Accordion.propTypes = propTypes;
Accordion.displayName = 'Accordion';
export default Accordion;